import { Injectable, OnInit } from '@angular/core';
import { ApiService } from './api.service';


@Injectable({
    providedIn: 'root'
})
export class CustomizeMenuService implements OnInit {

    featureTags = {};
    MenusHeight: any = {};
    public screenWidth: any;
    public screenHeight: any;
    Menus: any = {};
  wordWidths: Map<string, number> = new Map();




    constructor(private apiService: ApiService,) { }

    ngOnInit() {
        // this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));

    }

    cutomizeMenuDetails(Menu) {

        // if (this.featureTags['category_menu_auto_generate']) {
            this.apiService.categories().subscribe(result => {
                let arr = [];
                arr = [...result['response']['data']['cat_list']];

                let sortedProducts = arr.sort(
                    (p1, p2) => (p1.id < p2.id) ? 1 : (p1.id > p2.id) ? -1 : 0);

                this.screenWidth = window.innerWidth;
                this.screenHeight = window.innerHeight;
                // const calculatedValue = this.screenWidth * 0.01;
                const calculatedValueHeight = this.screenHeight * 0.01;
                // const maxwidth = 5;
                // console.log("width", this.screenWidth, "Height", this.screenHeight, "screen calc", calculatedValue, calculatedValueHeight, sortedProducts.length)
                // var wholenum = Math.floor(calculatedValue);
                var wholenumHeight = Math.floor(calculatedValueHeight);
                // this.Menus['sortedLinks'] = sortedProducts.slice(0, wholenum);
                var data = [{
                    title: "PRODUCTS"
                }]
                this.MenusHeight['sortedHeight'] = [...data, ...sortedProducts.slice(0, wholenumHeight - 2)];
                // this.Menus['sortedLinks'].forEach(obj => {
                //   obj['category_name'].length > maxwidth ? obj['category_name_load'] = obj['category_name'].substring(0, maxwidth) + '...' : obj['category_name_load'] = obj['category_name'];
                //   console.log("check objecct trimmmmmmmmmmmmmmmmm else", obj['category_name_load']);
                // });
                let width
                let totalWidth = 0;
                let indexToRemove = -1;
                let chk = true;
                var chkwidth = this.screenWidth;
                var finwidth = chkwidth - 500;
                // Calculate total width of menu items
                sortedProducts.forEach((word, index) => {
                    width = this.getTextWidth(word.category_name, '16px Arial'); // Adjust font size and type as needed
                    this.wordWidths.set(word.category_name, width);
                    totalWidth += this.wordWidths.get(word.category_name);
                    if (totalWidth > finwidth && chk) {
                        indexToRemove = index;
                        chk = false;
                    } else if (chk) {
                        indexToRemove = -1;
                    }
                });
                if (indexToRemove !== -1) {
                    sortedProducts.splice(indexToRemove, sortedProducts.length - indexToRemove);
                    this.Menus['sortedLinks'] = sortedProducts;
                } else {
                    this.Menus['sortedLinks'] = sortedProducts
                }
                this.Menus.title = [{ title: "ALL CATEGORY", url: "categories" }, { title: "CONTACT US", url: "contact" }]
            })
        // } else {
        //     for (let c = 0; c < Menu["desktop_links"].length; c++) {
        //         if (Menu["desktop_links"][c]["title"]["name"] == "Orders") {
        //             Menu["desktop_links"][c]["title"]["name"] = "Dashboard";
        //         } else {
        //             for (let d = 0; d < Menu["desktop_links"][c]["links"].length; d++) {
        //                 if (Menu["desktop_links"][c]["links"][d]["name"] == "Bulletin Board") {
        //                     Menu["desktop_links"][c]["links"].splice(d, 1);
        //                 }
        //             }
        //         }
        //     }
        //     for (let c = 0; c < Menu["links"].length; c++) {
        //         if (Menu["links"][c]["title"]["name"] == "Orders") {
        //             Menu["links"][c]["title"]["name"] = "Dashboard";
        //         }
        //         else {
        //             for (let d = 0; d < Menu["links"][c]["links"].length; d++) {
        //                 if (Menu["links"][c]["links"][d]["name"] == "Bulletin Board") {
        //                     Menu["links"][c]["links"].splice(d, 1);
        //                 }
        //             }
        //         }
        //     }
        // }
        return Menu;
    }

    getTextWidth(text: string, font: string): number {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
    }

}